<app-layout>

  <div class="row">
    <div class="col-12">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Tedarikçi Ödemeleri</h3>
        </div>
        <div class="card-body border-bottom py-3">
          <select [ngModel]="selectedSubeId" (ngModelChange)="onChangeSube($event)" class="form-control">
            <option [ngValue]="null" selected>Şube Seçin</option>
            <option [value]="sube.id" *ngFor="let sube of subeler">
              {{sube.isim}}
            </option>
          </select>

            <div class="row" style="margin-top: 30px;">
              <div class="col-12">
                
              </div>
            </div>


        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Yerel Talepler</h3>
          <!-- <div class="card-options">
            <div class="dropdown">
              <button type="button" class="btn btn-white dropdown-toggle ml-3" data-toggle="dropdown">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-md" width="24" height="24" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <circle cx="12" cy="12" r="1"></circle>
                  <circle cx="12" cy="19" r="1"></circle>
                  <circle cx="12" cy="5" r="1"></circle>
                </svg>
                Filtrele
              </button>
              <div class="dropdown-menu">
                <label class="dropdown-item" *ngFor="let f of filterStatus"><input class="form-check-input m-0 mr-2"
                    type="checkbox" [(ngModel)]="f.value" (click)="filter(f.key)">{{getDurumText(f.key)}}</label>
              </div>
            </div>
          </div> -->
        </div>
        <div class="card-body border-bottom py-3">
          <div class="d-flex">
            <div class="mr-auto text-muted">
              Arama yap:
              <div class="ml-2 d-inline-block">
                <div class="input-icon mb-3">
                  <span class="input-icon-addon" style="left:auto;right:0;" *ngIf="talepAraLoading">
                    <div class="spinner-border spinner-border-sm text-muted" role="status"></div>
                  </span>
                  <input name="kalemAra" [autocomplete]="true" type="text" class="form-control form-control-sm"
                    [(ngModel)]="talepAraText" placeholder="Yazın ve Enter'a basın"
                    (keyup.enter)="talepAraInputChange()">
                </div>
              </div>
            </div>
            <div class="text-muted">
              Gösterilen
              <div class="mx-2 d-inline-block">
                <select class="form-control form-control-sm" [(ngModel)]="showSearchResultCountTalep"
                  (change)="talepAraInputChange()">
                  <option *ngFor="let p of showSearchResultCountModelTalep" [ngValue]="p">{{p}}</option>
                </select>
              </div>
              sonuç sayısı
            </div>
          </div>
        </div>
        <app-talep-liste *ngIf="sourceTalep" [source]="sourceTalep.results" [isFatura]="sourceTalep.isFatura"
          (updateTalepler)="getTalepler()"></app-talep-liste>
        <div class="card-footer d-flex align-items-center" *ngIf="sourceTalep">
          <p class="m-0 text-muted"><span>{{sourceTalep.rowCount}}
              sonuçtan {{sourceTalep.firstRowOnPage}}</span>-<span>{{sourceTalep.lastRowOnPage}}</span> arası sonuçlar
          </p>
          <ul class="pagination m-0 ml-auto">
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPageTalep === 1}">
              <div class="page-link" tabindex="-1" (click)="showPreviousPageSearchResultsTalep()">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="15 6 9 12 15 18"></polyline>
                </svg>
                önceki
              </div>
            </li>
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPageTalep === sourceTalep.pageCount}">
              <div class="page-link" (click)="showNextPageSearchResultsTalep()">
                sonraki
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="9 6 15 12 9 18"></polyline>
                </svg>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Faturalar</h3>
          <div class="card-options">
            <div class="btn btn-sm btn-pill btn-success" (click)="new()">Yeni Fatura</div>
            <div class="dropdown">
              <button type="button" class="btn btn-white dropdown-toggle ml-3" data-toggle="dropdown">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-md" width="24" height="24" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <circle cx="12" cy="12" r="1"></circle>
                  <circle cx="12" cy="19" r="1"></circle>
                  <circle cx="12" cy="5" r="1"></circle>
                </svg>
                Filtrele
              </button>
            </div>
          </div>
        </div>
        <div class="card-body border-bottom py-3">
          <div class="d-flex">
            <div class="mr-auto text-muted">
              Arama yap:
              <div class="ml-2 d-inline-block">
                <div class="input-icon mb-3">
                  <span class="input-icon-addon" style="left:auto;right:0;" *ngIf="faturaAraLoading">
                    <div class="spinner-border spinner-border-sm text-muted" role="status"></div>
                  </span>
                  <input name="kalemAra" [autocomplete]="true" type="text" class="form-control form-control-sm"
                    [(ngModel)]="faturaAraText1" placeholder="Yazın ve Enter'a basın"
                    (keyup.enter)="faturaAraInputChange(1)">
                </div>
              </div>
            </div>
            <div class="text-muted">
              Gösterilen
              <div class="mx-2 d-inline-block">
                <select class="form-control form-control-sm" [(ngModel)]="showSearchResultCount1"
                  (change)="faturaAraInputChange(1)">
                  <option *ngFor="let p of showSearchResultCountModel" [ngValue]="p">{{p}}</option>
                </select>
              </div>
              sonuç sayısı
            </div>
          </div>
        </div>
        <app-fatura-liste *ngIf="source" [source]="source.results" (updateList)="getFaturalar()"></app-fatura-liste>
        <div class="card-footer d-flex align-items-center" *ngIf="source">
          <p class="m-0 text-muted"><span>{{source.rowCount}}
              sonuçtan {{source.firstRowOnPage}}</span>-<span>{{source.lastRowOnPage}}</span> arası sonuçlar
          </p>
          <ul class="pagination m-0 ml-auto">
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPage1 === 1}">
              <div class="page-link" tabindex="-1" (click)="showPreviousPageSearchResults(1)">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="15 6 9 12 15 18"></polyline>
                </svg>
                önceki
              </div>
            </li>
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPage1 === source.pageCount}">
              <div class="page-link" (click)="showNextPageSearchResults(1)">
                sonraki
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="9 6 15 12 9 18"></polyline>
                </svg>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Netsise Aktarılan Faturalar</h3>
          <!-- <div class="card-options">
            <div class="dropdown">
              <button type="button" class="btn btn-white dropdown-toggle ml-3" data-toggle="dropdown">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-md" width="24" height="24" viewBox="0 0 24 24"
                     stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <circle cx="12" cy="12" r="1"></circle>
                  <circle cx="12" cy="19" r="1"></circle>
                  <circle cx="12" cy="5" r="1"></circle>
                </svg>
                Filtrele
              </button>
              <div class="dropdown-menu">
                <label class="dropdown-item" *ngFor="let f of filterStatus"><input class="form-check-input m-0 mr-2"
                                                                                   type="checkbox"
                                                                                   [(ngModel)]="f.value"
                                                                                   (click)="filter(f.key)">{{getDurumText(f.key)}}</label>
              </div>
            </div>
          </div> -->
        </div>
        <div class="card-body border-bottom py-3">
          <div class="d-flex">
            <div class="mr-auto text-muted">
              Arama yap:
              <div class="ml-2 d-inline-block">
                <div class="input-icon mb-3">
                  <span class="input-icon-addon" style="left:auto;right:0;" *ngIf="faturaAraLoading">
                    <div class="spinner-border spinner-border-sm text-muted" role="status"></div>
                  </span>
                  <input name="kalemAra" [autocomplete]="true" type="text" class="form-control form-control-sm"
                    [(ngModel)]="faturaAraText2" placeholder="Yazın ve Enter'a basın"
                    (keyup.enter)="faturaAraInputChange(2)">
                </div>
              </div>
            </div>
            <div class="text-muted">
              Gösterilen
              <div class="mx-2 d-inline-block">
                <select class="form-control form-control-sm" [(ngModel)]="showSearchResultCount2"
                  (change)="faturaAraInputChange(2)">
                  <option *ngFor="let p of showSearchResultCountModel2" [ngValue]="p">{{p}}</option>
                </select>
              </div>
              sonuç sayısı
            </div>
          </div>
        </div>
        <app-fatura-liste *ngIf="source2" [source]="source2.results" (updateList)="getFaturalar()"></app-fatura-liste>
        <div class="card-footer d-flex align-items-center" *ngIf="source2">
          <p class="m-0 text-muted"><span>{{source2.rowCount}}
              sonuçtan {{source2.firstRowOnPage}}</span>-<span>{{source2.lastRowOnPage}}</span> arası sonuçlar
          </p>
          <ul class="pagination m-0 ml-auto">
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPage2 === 1}">
              <div class="page-link" tabindex="-1" (click)="showPreviousPageSearchResults(2)">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="15 6 9 12 15 18"></polyline>
                </svg>
                önceki
              </div>
            </li>
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPage2 === source2.pageCount}">
              <div class="page-link" (click)="showNextPageSearchResults(2)">
                sonraki
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="9 6 15 12 9 18"></polyline>
                </svg>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</app-layout>